import { Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { agentUserPreviewsQueryKey } from "../user.keys";

export const useFetchAgentUserPreviews = () => {
	const { get } = useRequest();

	const { data, error, isLoading } = useQuery({
		queryKey: agentUserPreviewsQueryKey(),
		queryFn: async () =>
			await get<Dtos.Agent.UserPreview.Get.Response[]>(`/v2/agents/user-previews`),
		retry: false,
	});

	return {
		agentUserPreviews: data,
		agentUserPreviewsError: error,
		agentUserPreviewsLoading: isLoading,
	};
};
